import { render, staticRenderFns } from "./TablePaginationControls.vue?vue&type=template&id=288a7a0f&scoped=true&"
import script from "./TablePaginationControls.vue?vue&type=script&lang=ts&"
export * from "./TablePaginationControls.vue?vue&type=script&lang=ts&"
import style0 from "./TablePaginationControls.vue?vue&type=style&index=0&id=288a7a0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288a7a0f",
  null
  
)

export default component.exports